module.exports = __webpack_public_path__ + "img/avatar.f5ef4263.png";